// extracted by mini-css-extract-plugin
module.exports = {"btnGreen":"styles_btnGreen__2A3tm","btnRed":"styles_btnRed__3f4ru","formContent":"styles_formContent__dF5ls","form":"styles_form__yJbiR"};